import * as caching from "caching"

export const cache = new caching.Cache({ namespace: "novacloud.nav" })

export default cache
